(function () {
  'use strict';

  if (window.__BS_FORCE_P0_GUARD__) return;
  window.__BS_FORCE_P0_GUARD__ = '2026-08-05.2';

  var FORCE_PATH = '/products/the-force-tamper-58-5';
  var FORCE_VARIANT_ID = 41169670668390;
  var CHOOSER_PATH = '/pages/choose-a-free-pitcher';
  var HERO_BUTTON_ID = 'gTqMN7Bv4v';

  function findForceLine(cart) {
    return (cart && cart.items || []).find(function (item) {
      return Number(item.variant_id) === FORCE_VARIANT_ID;
    });
  }

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to verify your cart.');
      return response.json();
    });
  }

  function addForce() {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: FORCE_VARIANT_ID, quantity: 1 }]
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (error) {
          throw new Error(error.description || error.message || 'The Force Tamper could not be added.');
        });
      }
      return response.json();
    });
  }

  function clearError(button) {
    var message = button.parentElement && button.parentElement.querySelector('[data-bs-force-error]');
    if (message) message.remove();
  }

  function showError(button, error) {
    clearError(button);
    var message = document.createElement('p');
    message.setAttribute('data-bs-force-error', '');
    message.setAttribute('role', 'alert');
    message.style.cssText = 'margin:8px 0 0;color:#b42318;font-size:14px;line-height:1.4;';
    message.textContent = error && error.message
      ? error.message + ' Please try again.'
      : 'The Force Tamper could not be added. Please try again.';
    if (button.parentElement) button.parentElement.appendChild(message);
  }

  function handleHeroClick(event) {
    if (window.location.pathname.toLowerCase() !== FORCE_PATH) return;
    var target = event.target;
    var button = target && target.closest ? target.closest('[data-id="' + HERO_BUTTON_ID + '"]') : null;
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    clearError(button);
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    getCart()
      .then(function (cart) {
        return findForceLine(cart) ? cart : addForce().then(getCart);
      })
      .then(function (cart) {
        var line = findForceLine(cart);
        if (!line || Number(line.quantity) < 1) {
          throw new Error('The Force Tamper was not confirmed in your cart.');
        }
        window.location.assign(CHOOSER_PATH);
      })
      .catch(function (error) {
        console.error('[Barista Swag Force purchase guard]', error);
        showError(button, error);
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }

  window.addEventListener('click', handleHeroClick, true);
}());
